import {
  Button,
  Checkbox,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@ac-expo/ui-components";
import CaretDownIcon from "../../../public/images/svg/SvgWebIcon/CaretDownIcon";
import filterStore from "../../services/FilterStore";
import { TrashIcon } from "@web-app/src/icons";

export function SideFilter() {
  const selectedTags = filterStore.selectedEventTags;

  const handleCheckboxChange = (filter: string) => {
    const newTags = selectedTags.includes(filter)
      ? selectedTags.filter((tag) => tag !== filter)
      : [...selectedTags, filter];

    filterStore.setSelectedEventTags(newTags);
  };

  function handleResetFilters() {
    filterStore.selectedEventTags = [];
  }

  const getPlaceholder = () => {
    const firstTag = selectedTags.at(0);
    let label = "Autres filtres";

    if (firstTag === "paid") {
      label = "Payante";
    }
    if (firstTag === "free") {
      label = "Gratuite";
    }
    if (firstTag === "indoor") {
      label = "Intérieur";
    }
    if (firstTag === "outdoor") {
      label = "Extérieur";
    }

    if (selectedTags.length > 1) {
      return `${label} +${selectedTags.length - 1}`;
    }
    return label;
  };

  return (
    <Popover>
      <div className="flex w-full flex-row items-center gap-2">
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className="h-[41px] w-full justify-between bg-white font-normal text-gray-500"
          >
            {getPlaceholder()}
            <CaretDownIcon height={20} width={20} fill={"#344054"} />
          </Button>
        </PopoverTrigger>
        {filterStore.selectedEventTags.length > 0 && (
          <Button
            onClick={handleResetFilters}
            variant="ghost"
            aria-label="Réinitialiser les filtres"
            className="self-center p-0 px-1"
          >
            <TrashIcon height={15} width={15} fill={"#344054"} />
          </Button>
        )}
      </div>
      <PopoverContent className="h-[225px] border p-4">
        <div className="flex h-[193px] flex-col gap-4 rounded-s-lg">
          <div className="h-[107px] gap-4 rounded-s-lg border px-6">
            <p className="pt-6 text-gray-500">Entrée</p>
            <div className="flex h-[22px] items-center gap-4 pt-4">
              <Checkbox
                checked={selectedTags.includes("paid")}
                onCheckedChange={() => handleCheckboxChange("paid")}
              />
              <p className="gap-[2px] text-gray-500">Payante</p>
              <Checkbox
                checked={selectedTags.includes("free")}
                onCheckedChange={() => handleCheckboxChange("free")}
              />
              <p className="gap-[2px] text-gray-500">Gratuite</p>
            </div>
          </div>
          <div className="flex h-[70px] items-center gap-4 rounded-s-lg border px-6">
            <div className="flex h-[22px] items-center gap-4 py-6">
              <Checkbox
                checked={selectedTags.includes("indoor")}
                onCheckedChange={() => handleCheckboxChange("indoor")}
              />
              <p className="gap-[2px] text-gray-500">Intérieur</p>
              <Checkbox
                checked={selectedTags.includes("outdoor")}
                onCheckedChange={() => handleCheckboxChange("outdoor")}
              />
              <p className="gap-[2px] text-gray-500">Extérieur</p>
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default SideFilter;
